import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiMessageCircle } from 'react-icons/fi';
import { EmptyState } from '@/components/custom/empty-state';
import { FeedComment } from '@/pages/feed/feed-comment';
import { FiSend } from 'react-icons/fi';
import { Sheet, SheetBody, SheetContent } from '@/components/ui/sheet';
import { ChatForm } from '@/components/custom/chat';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ModalComments, ModalCommentsBody, ModalCommentsCount, ModalCommentsFooter, ModalCommentsHeader, ModalCommentsPinned, ModalCommentsTitle } from '@/components/custom/modal';

export function ExercisesQuestionsModalComments(props) {
  const { show, onClose, createComment, commentText, setCommentText, isAdmin, answer, comments, deleteComment, setPinnedComment, recentComment } = props;

  const { t } = useTranslation();
  const sortedComments = [...comments].sort((a, b) => (b.pinned ? 1 : a.pinned ? -1 : 0));

  return (
    <Sheet
      open={show}
      onOpenChange={onClose}
    >
      <SheetContent size="md">
        <SheetBody className="py-10">
          <ModalComments>
            <ModalCommentsHeader>
              <ModalCommentsTitle>Comentários</ModalCommentsTitle>
              <ModalCommentsCount>
                <FiMessageCircle /> {comments?.length}
              </ModalCommentsCount>
            </ModalCommentsHeader>

            <ModalCommentsBody>
              {comments?.length === 0 && (
                <EmptyState
                  type="register"
                  title={'Seu comentário aparecerá aqui'}
                  text={'Digite e pressione enter para enviar'}
                  variant="plain"
                />
              )}

              {(isAdmin || (answer && comments && comments.length > 0)) &&
                sortedComments.map((comment, index) => (
                  <ModalCommentsPinned key={comment.id}>
                    <FeedComment
                      index={index}
                      comment={comment}
                      comments={comments}
                      deleteComment={comment => deleteComment(comment)}
                      pinned={comment.id === recentComment?.id}
                      setPinnedComment={setPinnedComment}
                    />
                  </ModalCommentsPinned>
                ))}
            </ModalCommentsBody>

            <ModalCommentsFooter>
              <ChatForm onSubmit={e => createComment(e)}>
                <Input
                  placeholder={t('textsCommon.placeholderSendYourComment')}
                  aria-label={t('textsCommon.placeholderSendYourComment')}
                  type="text"
                  name="comment"
                  id="comment"
                  onChange={e => setCommentText(e.target.value)}
                  value={commentText}
                />
                <Button
                  size="icon"
                  type="submit"
                >
                  <FiSend />
                </Button>
              </ChatForm>
            </ModalCommentsFooter>
          </ModalComments>
        </SheetBody>
      </SheetContent>
    </Sheet>
  );
}
